import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBRow, MDBCol, MDBIcon  } from 'mdbreact';
import {  MDBTabPane, MDBTabContent, MDBNav, MDBNavItem, MDBNavLink } from "mdbreact";
import Axios from 'axios'
import { Steps, Alert  } from 'antd';
import { Chart } from "react-google-charts";

import adminfaculty from '../adminfaculty/adminfaculty';
import Modalarticletyps from './Modalarticletypes';






export default class superadminaddress extends Component {

    constructor(props) {
        super(props);
        this.state = {
          articlesci1:[],
          articlehum1:[],
          articlesci2:[],
          articlehum2:[],
            article2:[],
            activeItem: "1"
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
      }


      toggle = tab => e => {
        if (this.state.activeItem !== tab) {
          this.setState({
            activeItem: tab
          });
        }
      };


    componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           //ภายใน
            Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticleaddress.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlesci1: res.data})
           }) 

        //    Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlehum1.php')
        //    .then(res => {
        //      console.log(res);
        //    //  this.setState({ bankname: res.data, loading: false })
        //      this.setState({ articlehum1: res.data})
        //    }) 

        //    //ภายนอก
        //    Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticle2.php')
        //    .then(res => {
        //      console.log(res);
        //    //  this.setState({ bankname: res.data, loading: false })
        //      this.setState({ articlesci2: res.data})
        //    }) 

        //    Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlehum2.php')
        //    .then(res => {
        //      console.log(res);
        //    //  this.setState({ bankname: res.data, loading: false })
        //      this.setState({ articlehum2: res.data})
        //    }) 
         }, 0);



      }

      updateat(){
        setTimeout(() => {
           
          Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticle1.php')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 

         Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticle2.php')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article2: res.data})
         }) 




       }, 0);
      }

  

    render() {
        const { Step } = Steps;
        return (
            <MDBContainer >
            <div>
            <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')}</p>
            <p className="text-right">การประชุมวิชาการระดับชาติครุศาสตร์ศึกษา ครั้งที่ 8 มหาวิทยาลัยราชภัฏกำแพงเพชร(ผู้ดูแลระบบกลาง)</p> 
         
                <MDBAlert color="success" >
                   <h2><MDBIcon icon="map-marked-alt" /> ที่อยู่สำหรับจัดส่งเอกสาร</h2>
                </MDBAlert>

                <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้ลงทะเบียน</th>
                        <th>สาขา</th>
                        <th>ที่อยู่</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articlesci1.map((articlesci1,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlesci1.send_name}</td>
                        <td>{articlesci1.register_pname}{articlesci1.register_nameth} {articlesci1.register_lnameth}</td>
                        <td>{articlesci1.major_precent}</td>
                        <td>เลขที่ {articlesci1.register_numhome} ม.{articlesci1.register_moo} หมู่บ้าน {articlesci1.register_street} ซอย.{articlesci1.register_soi	} ต.{articlesci1.DISTRICT_NAME} อ.{articlesci1.AMPHUR_NAME} จ.{articlesci1.PROVINCE_NAME} {articlesci1.register_zipcode} <br/>{articlesci1.register_phone} <br/>{articlesci1.register_email} 	</td>
                    
                        </tr>
                      )}
                    </MDBTableBody>
           </MDBTable>

            </div>
            </MDBContainer>
        )
    }
}
